import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=f1afa772&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports